import { LeadsDataSource } from '../../../utils/apis/leadsApiUtils';
import { getNvisionAnalyzeLeadsUrl } from '../../../utils/urlUtils';
export const getTopLeadSourcesLink = (source, dateRange) => {
    if (source === LeadsDataSource.VIN_SOLUTIONS) {
        return 'https://www.vinsolutions.com';
    }
    return getNvisionAnalyzeLeadsUrl(dateRange, true);
};
export const getFormattedTopLeadSourcesFromResponse = (topLeadSourcesResponse) => {
    const { topLeadSources, otherLeadSourcesCount, lastUpdatedUTC, } = topLeadSourcesResponse || {};
    return {
        topLeadSources: (topLeadSources || []).map(({ sourceName, leadCount }) => ({
            description: `Lead${leadCount === 1 ? '' : 's'} from ${sourceName}`,
            value: leadCount,
        })),
        remaining: otherLeadSourcesCount,
        lastUpdatedUTC,
    };
};
